import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { PATHS } from 'shared/paths';
import { Account, Article } from 'shared/types';
import { Page, Section, SubSection } from 'shared/location-enums';
import { DiseaseService } from 'src/app/services/disease.service';
import { AccountService } from 'src/app/services/account.service';
import { PatientAdvocacyGroup } from 'src/app/components/common/organizations/organizations-interfaces';
import { availablePatientAdvocacyGroups } from 'src/app/components/common/organizations/patient-advocacy-groups';

@Component({
    selector: 'rare-disease-expert',
    templateUrl: './rare-disease-expert.component.html',
    styleUrls: ['./rare-disease-expert.component.scss'],
})
export class RareDiseaseExpertComponent {
    private readonly desktopBreakpoint = 992;
    private readonly mobileClampLines = 8;
    private readonly unclampedLines = 1000;

    public titleKA = 'Rare Disease Experts';
    public imgPath = PATHS.articleImages;
    public bodyMaxLines = this.unclampedLines;

    public mainKA: Article;

    public linkKA: Article;

    public nullKA: Article;

    public orgsWithExpertDirectory: PatientAdvocacyGroup[] = [];

    constructor(
        private articleService: ArticleService,
        private diseaseService: DiseaseService,
        private accountService: AccountService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.setBodyMaxLines();
        this.mainKA = this.articleService.getOne(Page.diagnosis, Section.findingExpert, SubSection.parent, undefined, undefined, false);

        this.linkKA = this.articleService.getOne(Page.diagnosis, Section.findingExpert, SubSection.moreInfo, undefined, undefined, false);

        this.nullKA = this.articleService.getOne(Page.diagnosis, Section.findingExpert, SubSection.moreInfo, undefined, undefined, true);

        // add replacement for disease name
        this.linkKA.bodyText = this.linkKA.bodyText.replace('${DiseaseName}', this.diseaseService.disease.name);

        // Accounts logic
        const patientAdvocacyGroups: Account[] = this.accountService.getAccounts();

        // PAGs logic
        const pagsForDiseaseAndTag = availablePatientAdvocacyGroups(patientAdvocacyGroups, this.diseaseService.disease, true, true, false);
        const orgsWithExpertDirectoryAll = pagsForDiseaseAndTag.filter((org: PatientAdvocacyGroup) => org.expertDirectoryUrl);

        // USA only
        this.orgsWithExpertDirectory = orgsWithExpertDirectoryAll.filter((org: PatientAdvocacyGroup) => org.country === 'United States');
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.setBodyMaxLines();
    }

    private setBodyMaxLines() {
        const width = this.document.defaultView?.innerWidth ?? this.desktopBreakpoint;
        this.bodyMaxLines = width >= this.desktopBreakpoint ? this.unclampedLines : this.mobileClampLines;
    }
}
